<template>
  <div class="vx-row flex flex-col">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <h3>{{devices.name}}</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'devices-edit',params:{id: devices.id}})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-edit"
            class="mb-4 self-end"
            size="medium"
          >Edit Devices</vs-button>
          <vs-table :data="[1]">
            <template slot="thead">
              <th style="width: 200px;"></th>
              <th style="width: 20px;"></th>
              <th></th>
            </template>
            <tbody>
              <tr>
                <td>Nama Devices</td>
                <td>:</td>
                <td>{{devices.name}}</td>
              </tr>
              <tr>
                <td>Token Devices</td>
                <td>:</td>
                <td>{{devices.token}}</td>
              </tr>
              <tr>
                <td>Tipe Devices</td>
                <td>:</td>
                <td>{{devices.type}}</td>
              </tr>
              <tr>
                <td>Deskripsi Devices</td>
                <td>:</td>
                <td>{{devices.description }}</td>
              </tr>
            </tbody>
          </vs-table>
        </div>
      </vs-card>
      <vs-card>
        <div slot="header">
          <h3>LIST COUNTER {{devices.name}}</h3>
        </div>
        <div class="flex flex-col">
          <vs-button
            @click="$router.push({name: 'devices-detail-group-create', params : {id : $route.params.id}})"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-plus"
            class="mb-4 self-end"
            size="medium"
          >Tambah Counter</vs-button>
          <vs-table :data="counters">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Nama Loket</vs-th>
              <vs-th>Deskripsi</vs-th>
              <vs-th>Pilihan</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.counter_name">{{ tr.counter_name }}</vs-td>
                <vs-td :data="tr.counter_description">{{ tr.counter_description }}</vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vs-button
                      @click="deleteCounter(tr.id)"
                      type="border"
                      color="danger"
                      size="small"
                      class="m-1"
                      icon-pack="feather"
                      icon="icon-trash"
                    >Hapus Loket</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
      <vs-button
        @click="$router.push({name: 'devices'})"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-4 self-end"
        size="medium"
      >Kembali</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      devices : [],
      counters : [],
      cluster : []
    };
  },
  mounted() {
    this.getDevice();
  },
  methods: {
    deleteCounter(counter_id){
      this.$vs.loading();
      this.$http
        .post(`/app/secure/devices/delete-group-devices`, {
          group_device_id : counter_id
        })
        .then(() => {
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil menghapus counter.",
            color: "success",
            position: "top-right"
          });
          this.getDevice();
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getDevice() {
      this.$http
      .get(`/app/secure/devices/${this.$route.params.id}/show`)
      .then(r => {
        this.devices = r.data.data.devices;
        this.counters = r.data.data.group_devices;
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    },

  }
};
</script>>